import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

export interface EnzymeCatalogItemProps {
  /** Whether the enzyme is also in the panel's list of active enzymes */
  active: boolean;
  /** Whether the catalog should be visible */
  catalogVisible: boolean;
  /** Whether to hide the list of cut sites */
  hideCutPositions: boolean;
  /** Whether to highlight the enzyme row */
  highlight: boolean;
  /** The name of the enzymes */
  name: string;
  /** Function to be called when the enzyme is clicked */
  onClick: () => void;
  /** Function to be called when the enzyme is hovered */
  onMouseOver: () => void;
  /** How many cut sites for this enzyme exist on the sequence being viewed */
  sites: number;
}

export default function EnzymeCatalogItem({
  active,
  catalogVisible,
  hideCutPositions,
  highlight,
  name,
  onClick,
  onMouseOver,
  sites,
}: EnzymeCatalogItemProps): JSX.Element {
  if (!catalogVisible) {
    return <></>;
  }
  return (
    <tr
      className={classNames(css(styles.wrapper), {active, [css(styles.highlight)]: highlight})}
      onMouseOver={onMouseOver}
      onClick={onClick}
      {...getTestProps({component: 'EnzymeCatalogItem', element: 'row'})}
    >
      <td
        className={classNames('mono', css(styles.enzymeNameCell))}
        {...getTestProps({component: 'EnzymeRow', element: 'name'})}
      >
        {name}
      </td>
      {!hideCutPositions && (
        <td
          {...getTestProps({component: 'EnzymeRow', element: 'sites'})}
          className={css(styles.cutsiteCountCell)}
        >
          {sites}
        </td>
      )}
    </tr>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    cursor: 'pointer',
  },
  highlight: {
    fontWeight: 'bold',
  },
  enzymeNameCell: {
    width: '120px',
    textAlign: 'left',
  },
  cutsiteCountCell: {
    width: '80px',
  },
});
